<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div>
          <h1>{{ 'CashFunding_Dashboard_Title' | translateWF: 'Cash Funding' }}</h1>
        </div>
        <div class="page__title_buttons">
          <p-button [label]="'CashFunding_New' | translateWF: 'New funding'" icon="pi pi-plus" (click)="newFunding()" />
        </div>
      </div>
    </div>

    <!-- Summary ───────────────────────────────────────────────────────────── -->
    <div class="cs-summary-grid">
      <p-card data-variant="summary" [header]="'CashFunding_FundedThisWeek' | translateWF: 'Funded this week'">
        <ng-template pTemplate="subtitle">{{ fundedThisWeek() | number: '1.2-2' }}</ng-template>
      </p-card>
      <p-card data-variant="summary" [header]="'CashFunding_FundedThisMonth' | translateWF: 'Funded this month'">
        <ng-template pTemplate="subtitle">{{ fundedThisMonth() | number: '1.2-2' }}</ng-template>
      </p-card>
      <p-card data-variant="summary" [header]="'CashFunding_Posted' | translateWF: 'Posted'">
        <ng-template pTemplate="subtitle">{{ postedCount() }}</ng-template>
      </p-card>
      <p-card data-variant="summary" [header]="'CashFunding_Drafts' | translateWF: 'Drafts'">
        <ng-template pTemplate="subtitle">{{ draftCount() }}</ng-template>
      </p-card>
    </div>

    <!-- Filters + table ─────────────────────────────────────────────────────── -->
    <div class="cs-page-list-grid">
      @if (filterConfig()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }
      <div>
        <p-table [value]="paginatedFundings()" [rowTrackBy]="trackById" [rowHover]="true">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'CashFunding_Number' | translateWF: 'Number' }}</th>
              <th>{{ 'CashFunding_Funder' | translateWF: 'Funder' }}</th>
              <th>{{ 'CashFunding_CashRequest' | translateWF: 'Cash Request' }}</th>
              <th>{{ 'CashFunding_Date' | translateWF: 'Funded' }}</th>
              <th class="text-right">{{ 'CashFunding_Amount' | translateWF: 'Amount' }}</th>
              <th class="text-center">{{ 'Status' | translateWF: 'Status' }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td class="font-mono text-sm">
                <a class="cs-table-link" (click)="view(row)">{{ row.number }}</a>
              </td>
              <td>{{ row.funderName || '—' }}</td>
              <td class="font-mono text-xs text-[var(--p-text-muted-color)]">{{ row.cashRequestNumber || '—' }}</td>
              <td class="text-sm">{{ row.fundingDate | date: 'dd/MM/yyyy' }}</td>
              <td class="text-right tabular-nums">{{ row.amount | number: '1.2-2' }} {{ currencyLabel(row.currency) }}</td>
              <td class="text-center">
                <p-tag [severity]="statusSeverity(row.status)" [value]="statusLabel(row.status) | translateWF: statusLabel(row.status)" />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center text-sm text-[var(--p-text-muted-color)] py-6">
                {{ 'CashFunding_Empty' | translateWF: 'No cash fundings yet.' }}
              </td>
            </tr>
          </ng-template>
        </p-table>
        <p-paginator
          [rows]="pageSize()"
          [totalRecords]="totalRecords()"
          [first]="(currentPage() - 1) * pageSize()"
          (onPageChange)="onPageChange($event)"
          [rowsPerPageOptions]="[25, 50, 100]"
        />
      </div>
    </div>
  </div>
</main>
